{
  "error": "Error",
  "help": "Ayuda",
  "info": "Información",
  "success": "Éxito",
  "warning": "Advertencia"
}
